// extracted by mini-css-extract-plugin
export var active = "_jd-2";
export var recordingDot = "_jd-1";
export var recordingIndicator = "_jd-0";